import React from 'react';
import ModalShell from '../ModalShell/ModalShell';
import './ConfirmActionModal.css';

interface ConfirmActionModalProps {
  title: string;
  message: string;
  confirmLabel: string;
  cancelLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
}

const ConfirmActionModal: React.FC<ConfirmActionModalProps> = ({
  title,
  message,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
  loading = false,
}) => (
  <ModalShell onClose={onCancel} ariaLabel={title} className="modal confirm-action-modal">
    <div className="confirm-action-modal__content">
      <h3>{title}</h3>
      <p>{message}</p>
      <div className="confirm-action-modal__actions">
        <button type="button" className="secondary" onClick={onCancel} disabled={loading}>
          {cancelLabel}
        </button>
        <button type="button" className="danger" onClick={onConfirm} disabled={loading}>
          {confirmLabel}
        </button>
      </div>
    </div>
  </ModalShell>
);

export default ConfirmActionModal;
